"use client"

import { AreasOfFocus } from "@/components/sections/areas-of-focus"

type WhatWeHelpWithProps = {
  onBook?: (areaId: string, areaTitle: string) => void
}

export function WhatWeHelpWith({ onBook }: WhatWeHelpWithProps) {
  return (
    <AreasOfFocus
      title="What We Help With"
      subtitle="These are the main areas of care Renee focuses on, supporting you through different stages of life with the same steady, relationship-based care."
      endtitle=""
      onBook={onBook}
      fromHomepage={true}
      sectionId="what-we-help-with-section"
    />
  )
}

